// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const BulkUsersService = {
    /**
     * get job status for jobs to invite or update users
     */
    JobStatus(fn, req) {
        try {
            fm.validateUrlParam(req["jobId"], "jobId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/bulk-users-api/v1/status/${req["jobId"]}?${fm.renderURLSearchParams(req, ["jobId"])}`, { method: "GET" });
    },
    /**
     * submits job to invite users and returns job id. job id can be used to track status.
     */
    InviteUsers(fn, req) {
        return fn(`/bulk-users-api/v1/users/invite`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    AddOrReplaceUserAccess(fn, req) {
        return fn(`/bulk-users-api/v1/users/access`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
